import { AvField, AvForm } from "availity-reactstrap-validation";
import React, { useEffect, useState } from "react";
import {
  Col, Label, Row
} from "reactstrap";
import { useSelector } from "react-redux";

export default function BillingForm({ t, setIsFirstStepValid, setPaymentPayload }) {
  const { clientData } = useSelector((state) => state.Profile);
  
  const [billingData, setBillingData] = useState({
    email: clientData?.email || "",
    address: clientData?.address || "",
    city: clientData?.city || "",
    postalCode: clientData?.zipCode || "",
    country: clientData?.country || "",
  });

  useEffect(() => {
    // Check if all required fields are filled
    const allFieldsFilled = 
      billingData.email &&
      billingData.address &&
      billingData.city &&
      billingData.postalCode &&
      billingData.country;

    setIsFirstStepValid(allFieldsFilled);

    // Update payment payload with billing data
    if (allFieldsFilled) {
      setPaymentPayload(billingData);
    }
  }, [billingData, setIsFirstStepValid, setPaymentPayload]);

  const handleFieldChange = (field, value) => {
    setBillingData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <div className="my-3">
      <p className="text-muted">{t("Please enter your billing information")}</p>
      <AvForm>
        <Row>
          <Col xs={12}>
            <div className="mb-3">
              <Label htmlFor="billing-email" className="form-label">
                {t("Email")} <span className="text-danger">*</span>
              </Label>
              <AvField
                className="form-control"
                type="email"
                id="billing-email"
                name="email"
                value={billingData.email}
                onChange={(e) => handleFieldChange("email", e.target.value)}
                validate={{
                  required: {
                    value: true,
                    errorMessage: t("Email is required"),
                  },
                  email: {
                    value: true,
                    errorMessage: t("Please enter a valid email"),
                  },
                }}
              />
            </div>
          </Col>

          <Col xs={12}>
            <div className="mb-3">
              <Label htmlFor="billing-address" className="form-label">
                {t("Address")} <span className="text-danger">*</span>
              </Label>
              <AvField
                className="form-control"
                type="text"
                id="billing-address"
                name="address"
                value={billingData.address}
                onChange={(e) => handleFieldChange("address", e.target.value)}
                validate={{
                  required: {
                    value: true,
                    errorMessage: t("Address is required"),
                  },
                  minLength: {
                    value: 5,
                    errorMessage: t("Address must be at least 5 characters"),
                  },
                }}
              />
            </div>
          </Col>

          <Col md={6}>
            <div className="mb-3">
              <Label htmlFor="billing-city" className="form-label">
                {t("City")} <span className="text-danger">*</span>
              </Label>
              <AvField
                className="form-control"
                type="text"
                id="billing-city"
                name="city"
                value={billingData.city}
                onChange={(e) => handleFieldChange("city", e.target.value)}
                validate={{
                  required: {
                    value: true,
                    errorMessage: t("City is required"),
                  },
                  minLength: {
                    value: 2,
                    errorMessage: t("City must be at least 2 characters"),
                  },
                }}
              />
            </div>
          </Col>

          <Col md={6}>
            <div className="mb-3">
              <Label htmlFor="billing-postal-code" className="form-label">
                {t("Postal Code")} <span className="text-danger">*</span>
              </Label>
              <AvField
                className="form-control"
                type="text"
                id="billing-postal-code"
                name="postalCode"
                value={billingData.postalCode}
                onChange={(e) => handleFieldChange("postalCode", e.target.value)}
                validate={{
                  required: {
                    value: true,
                    errorMessage: t("Postal code is required"),
                  },
                  minLength: {
                    value: 3,
                    errorMessage: t("Postal code must be at least 3 characters"),
                  },
                }}
              />
            </div>
          </Col>

          <Col xs={12}>
            <div className="mb-3">
              <Label htmlFor="billing-country" className="form-label">
                {t("Country")} <span className="text-danger">*</span>
              </Label>
              <AvField
                className="form-control"
                type="text"
                id="billing-country"
                name="country"
                value={billingData.country}
                onChange={(e) => handleFieldChange("country", e.target.value)}
                validate={{
                  required: {
                    value: true,
                    errorMessage: t("Country is required"),
                  },
                  minLength: {
                    value: 2,
                    errorMessage: t("Country must be at least 2 characters"),
                  },
                }}
              />
            </div>
          </Col>
        </Row>
      </AvForm>
    </div>
  );
}
